import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Section } from '../ui/Section';
import { SectionTitle, Accent } from '../ui/SectionTitle';
import { CtaButton } from '../ui/CtaButton';
import { resultOutcomes } from '../../data/content';
import { images } from '../../data/images';
export function ResultsSection() {
  return <Section id="resultados" tone="ink" data-id="element-235" data-mp="31mnlqolb5z0e">
      <div className="mx-auto max-w-4xl text-center" data-id="element-236" data-mp="31nqaapv5rpd5">
        <p className="flex items-center justify-center gap-3 text-xs font-semibold uppercase tracking-[0.2em] text-brand sm:text-sm" data-id="element-237" data-mp="32f3pxwu75oc">
          <span className="h-0.5 w-8 bg-brand" aria-hidden="true" data-id="element-238" data-mp="3ucdroacsdulf" />
          Resultados reales
          <span className="h-0.5 w-8 bg-brand" aria-hidden="true" data-id="element-239" data-mp="3ph86jdr7kjye" />
        </p>
        <SectionTitle className="mt-6" data-id="element-240" data-mp="3kjosoeyfa96z">
          Cuando hay dirección, el progreso <Accent data-id="element-241" data-mp="lv9iorugmxsk">deja de ser una adivinanza.</Accent>
        </SectionTitle>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-muted" data-id="element-242" data-mp="h2zlqruxgxgs">
          Estos son algunos resultados de personas que decidieron dejar de improvisar y empezar a entrenar, comer y
          avanzar con una estructura clara.
        </p>
      </div>

      <div className="mt-14 grid gap-10 lg:grid-cols-12 lg:items-center lg:gap-16" data-id="element-243" data-mp="4va54wqh3d0w">
        <figure className="relative lg:col-span-7" data-id="element-244" data-mp="3m9fc9dlo7mae">
          <div className="overflow-hidden rounded-lg border border-line bg-surface p-2 sm:p-3" data-id="element-245" data-mp="3r88o71lb758g">
            <img src={images.results} alt="Collage de transformaciones físicas de clientes, con fotos de antes y después" className="aspect-square w-full rounded-md object-cover" data-id="element-246" data-mp="3d8hgtjpasn3f" />
          </div>
          <span className="absolute -left-px top-8 h-16 w-1 bg-brand sm:top-10 sm:h-24" aria-hidden="true" data-id="element-247" data-mp="33cnvpbxijla1" />
        </figure>

        <div className="lg:col-span-5" data-id="element-248" data-mp="11j6ryjci74kk">
          <p className="text-lg leading-relaxed text-muted" data-id="element-249" data-mp="11k9k0ulkbd22">
            Cada cuerpo responde diferente, y los resultados dependen del punto de partida, la constancia y el
            compromiso de cada persona.{' '}
            <span className="text-white" data-id="element-250" data-mp="14z1b6t3cx6ig">
              Pero el principio es el mismo: cuando tu entrenamiento, alimentación y seguimiento trabajan juntos,
              empiezas a ver cambios que antes parecían imposibles.
            </span>
          </p>

          <ul className="mt-8 divide-y divide-line border-y border-line" data-id="element-251" data-mp="q5es2fkfagzv">
            {resultOutcomes.map(o => <li key={o} className="flex items-center gap-4 py-4" data-id="element-252" data-mp="1nr3ru4g00msp">
                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brand" data-id="element-253" data-mp="1ittwy99ubixh">
                  <CheckIcon className="h-3.5 w-3.5 text-white" strokeWidth={3} aria-hidden="true" data-id="element-254" data-mp="1e0r9mivnp5pq" />
                </span>
                <span className="font-display text-xl font-bold uppercase leading-tight text-white sm:text-2xl" data-id="element-255" data-mp="192pjjdztc64r">
                  {o}
                </span>
              </li>)}
          </ul>

          <div className="mt-10 flex flex-col items-start gap-3" data-id="element-256" data-mp="21pk03ztielcy">
            <CtaButton className="w-full sm:w-auto" data-id="element-257" data-mp="2a1lz0u2k9d5z" />
            <p className="text-sm text-muted" data-id="element-258" data-mp="2e1w6kb604bmy">Gratis. Sin compromiso. Solo claridad sobre tu próximo paso.</p>
          </div>
        </div>
      </div>
    </Section>;
}